<template>
  <div v-if="readiness" class="border rounded p-3 mb-5 bg-light">
    <div class="d-flex flex-wrap justify-content-between align-items-start">
      <div>
        <div class="font-weight-bolder text-dark">
          Next step
          <b-badge v-if="holdBadge" :variant="holdBadge.variant" class="ml-2">
            {{ holdBadge.label }}
          </b-badge>
        </div>
        <div v-if="readiness.complete" class="text-success">
          Ready — nothing left on the processing checklist for this row.
        </div>
        <div v-else-if="readiness.nextStep">
          <strong>{{ readiness.nextStep.label || plainNextStep }}</strong>
          <span v-if="readiness.nextStep.blockerReason" class="text-muted">
            — {{ readiness.nextStep.blockerReason }}
          </span>
          <div v-if="plainCommandHint" class="small text-muted mt-1">
            {{ plainCommandHint }}
          </div>
        </div>
        <div v-else class="text-muted">No next step available.</div>
      </div>
    </div>
  </div>
</template>

<script>
const COMMAND_HINTS = {
  "review-post": "Open Prepare and verify, then confirm post when ready.",
  "create-insight-client": "Create or link the INSIGHT client first.",
  "link-subagent": "Link the producing broker first.",
  "prepare-transaction": "Prepare the transaction draft first.",
  "stamp-back": "Stamp the Zoho work row after the invoice is posted.",
  "resolve-exception": "Resolve the exception on this row before continuing.",
  view: "View only — no action required.",
  PostToAccount: "Posting is never a checklist repair — use Open post confirmation."
};

export default {
  name: "ProcessingReadinessBanner",

  props: {
    readiness: {
      type: Object,
      default: null
    }
  },

  computed: {
    holdBadge: function () {
      const cls = this.readiness && this.readiness.holdClass;
      if (cls === "outcome_unknown") {
        return { variant: "danger", label: "Outcome unclear — do not post again" };
      }
      if (cls === "reconciliation_hold") {
        return { variant: "warning", label: "Posted — finish records only (no second post)" };
      }
      if (cls === "fixable") {
        return { variant: "secondary", label: "Fixable — return and repair" };
      }
      return null;
    },

    plainNextStep: function () {
      const code = this.readiness && this.readiness.nextStep && this.readiness.nextStep.code;
      return code ? String(code).replace(/_/g, " ") : "Next step";
    },

    plainCommandHint: function () {
      const cmd = this.readiness && this.readiness.nextCommand;
      if (!cmd) return null;
      return COMMAND_HINTS[cmd] || null;
    }
  }
};
</script>
